const isUrlPathMatch = (path, itemUrl) => {
  if (!itemUrl || !path) return false;
  const reg = new RegExp(/^[^#?]+/);
  const _path = reg.exec(path)[0];
  return _path === itemUrl || _path === `/${itemUrl}`;
};
export default isUrlPathMatch;
//# sourceMappingURL=isUrlPathMatch.js.map